import i18n from '../translations/i18n';
import { sweetAlert } from '../utils/popupUtils';
import store from './Store';

// Impersonation runs on a session the visitor does not own: there is nothing of theirs
// to log out of, and disconnect() would clear the admin's own localStorage session
// alongside the borrowed one.
export function isLogoutBlocked(): boolean {
  return !!store.impersonator;
}

async function warnLogoutBlocked(): Promise<void> {
  await sweetAlert({
    title: i18n.t('menu.logout-impersonate.title'),
    text: i18n.t('menu.logout-impersonate.text'),
    icon: 'info',
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
}

// The user-initiated logout. Warns instead of disconnecting when logout is blocked — the
// warning has to come first, since disconnecting reloads the page and would kill the popup.
// `onDisconnected` runs after the session is cleared and before the reload.
export async function requestLogout(onDisconnected?: () => void): Promise<void> {
  if (isLogoutBlocked()) {
    await warnLogoutBlocked();
    return;
  }
  await store.disconnect();
  onDisconnected?.();
  window.location.reload();
}
